import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './ContainerAggregationSection.module.css';
import { FaCheckCircle } from "react-icons/fa";

/**
 * Reusable Bullet List component
 */
const BulletList = ({ items }) => {
  return (
    <ul className={css.bulletList}>
      {items.map((item, index) => (
        <li key={index} className={css.bulletItem}>
          <div className={css.bulletIconWrapper} aria-hidden="true">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <span className={css.bulletText}>
            <FormattedMessage id={item} />
          </span>
        </li>
      ))}
    </ul>
  );
};

BulletList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

/**
 * MOQ Order Aggregation Section component
 */
const ContainerAggregationSection = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  const bullets = [
    'landing.aggregation.bullet1',
    'landing.aggregation.bullet2',
    'landing.aggregation.bullet3',
    'landing.aggregation.bullet4',
    'landing.aggregation.bullet5',
  ];

  return (
   <div className={css.main}>
    <div className={css.left}>
      <h1 className={css.text}>
        <FormattedMessage id="landing.aggregation.title" />
      </h1>
      <h3 className={css.subtext}>
        <FormattedMessage id="landing.aggregation.subtitle" />
      </h3>
      <div className={css.check1}>
        {bullets.map((bulletKey, index) => (
          <div key={index} className={css.check}>
            <FaCheckCircle className={css.icon} />
            <h4>
              <FormattedMessage id={bulletKey} />
            </h4>
          </div>
        ))}
      </div>
    </div>
    <div className={css.right}>
      <div className={css.flowDiagram}>
        <div className={css.flowHeader}>
          <span className={css.flowTag}>Same Product Demand Pooling</span>
          <h3 className={css.flowProductTitle}>Single SKU Demand Aggregation</h3>
        </div>

        <div className={css.buyersGrid}>
          <div className={css.buyerCard}>
            <div className={css.buyerLabel}>Buyer A</div>
            <div className={css.buyerQty}>300 pcs</div>
          </div>
          <div className={css.plusSign}>+</div>
          <div className={css.buyerCard}>
            <div className={css.buyerLabel}>Buyer B</div>
            <div className={css.buyerQty}>500 pcs</div>
          </div>
          <div className={css.plusSign}>+</div>
          <div className={css.buyerCard}>
            <div className={css.buyerLabel}>Buyer C</div>
            <div className={css.buyerQty}>200 pcs</div>
          </div>
        </div>

        <div className={css.arrowDown}>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="12" y1="4" x2="12" y2="19" />
            <polyline points="19 13 12 20 5 13" />
          </svg>
        </div>

        <div className={css.combinedCard}>
          <div className={css.combinedTop}>
            <span className={css.combinedTitle}>Combined Product Demand</span>
            <span className={css.combinedTotal}>1,000 pcs</span>
          </div>
          <div className={css.progressTrack}>
            <div className={css.progressBar} />
          </div>
          <div className={css.moqTarget}>Target Factory MOQ: 1,000 pcs (100% Reached)</div>
        </div>

        <div className={css.arrowDown}>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="12" y1="4" x2="12" y2="19" />
            <polyline points="19 13 12 20 5 13" />
          </svg>
        </div>

        <div className={css.productionCard}>
          <div className={css.productionBadge}>✓ Factory MOQ Reached</div>
          <div className={css.productionText}>
            Production Unlocked Under Applicable Wholesale Volume Pricing
          </div>
        </div>
      </div>
    </div>
   </div>
  );
};

ContainerAggregationSection.defaultProps = {
  className: null,
  rootClassName: null,
};

ContainerAggregationSection.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default ContainerAggregationSection;
export { BulletList };
